import { REST_API_PRIMAREY_KEY, AIRTABLE } from 'drapcode-constant';
export const filters = [
  'createdBy',
  'createdAt',
  'updatedAt',
  'uuid',
  'isDeleted',
  REST_API_PRIMAREY_KEY,
];
export const createLinkForCreate = (projectId, version, activeTab) => {
  switch (activeTab) {
    case AIRTABLE:
      return `/2.0/data-connector/${version}/v/${projectId}/airtable/create`;
    default:
      break;
  }
};

export const externalDataGrouping = (data) => {
  const groupingData = {};
  data.forEach((item) => {
    const { type } = item;
    if (!groupingData[type]) {
      groupingData[type] = [];
    }
    groupingData[type].push(item);
  });

  return groupingData;
};
